<nav>
    @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last; let first = $first) {
        <ng-container>
            <span class="breadcrumb">
                @if (!last && breadcrumb.path.length > 0) {
                    <a [routerLink]="breadcrumb.url"> ({{ breadcrumb.label | transloco }}).trim() </a>
                } @else {
                    {{ breadcrumb.label | transloco }}
                }

                @if (!last) {
                    &nbsp;/&nbsp;
                }
            </span>
        </ng-container>
    }
</nav>
